import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { AiChatSuggestionComponent } from './ai-chat-suggestion.component';
import { NgForOf } from '@angular/common';
import { Suggestion } from '@panaya/ai-chat/domain';

@Component({
    standalone: true,
    selector: 'ai-chat-suggestions',
    imports: [PIconModule, AiChatSuggestionComponent, NgForOf, TranslateModule],
    templateUrl: './ai-chat-suggestions.component.html',
    styleUrls: ['./ai-chat-suggestions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatSuggestionsComponent {
    @Input() public suggestions: Suggestion[] = [];
}
